import articleImage from '../assets/images/Article-Article.png';
import articleIcon from '../assets/images/article-icon.svg';
import highlightTip from '../assets/images/highlight (1).png';
import highlightAramesh from '../assets/images/highlight (2).png';
import highlightCoaching from '../assets/images/highlight (3).png';
import highlightLove from '../assets/images/highlight (4).png';
import highlightMotivation from '../assets/images/highlight (5).png';
import mainAvatar from '../assets/images/Main Avatar.png';
import playIcon from '../assets/images/Play.png';
import podcastImage from '../assets/images/Podcast-Article.png';
import podcastIcon from '../assets/images/Podcast-Icon.svg';
import sliderImage from '../assets/images/Slider-Article.png';
import sliderIcon from '../assets/images/Slider-Icon.svg';
import videoImage from '../assets/images/Video-Article.png';
import videoIcon from '../assets/images/Video-Icon.svg';

const demoVideoUrl = 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4';
const demoAudioUrl = 'https://dl.musicdel.ir/tag/music/1405/01/29/Mohsen%20Mohammadi%20Panah%20-%20Bayad%20Barkhast%20(128).mp3';

export const assets = {
  playIcon,
  articleImage,
  podcastImage,
  sliderImage,
  videoImage,
  mainAvatar
};

export const menuItems = [
  { label: 'خانه', href: 'index.html', key: 'home' },
  { label: 'درباره ما', href: 'about.html', key: 'about' },
  { label: 'فروشگاه', href: 'shop.html', key: 'shop' },
  { label: 'تست‌ها', href: 'tests.html', key: 'tests' },
  { label: 'تماس با ما', href: 'contact.html', key: 'contact' }
];

export const profile = {
  username: 'arameshrouzkhosh',
  name: 'آرامش روزخوش؛ مربی کسب و کار',
  avatar: mainAvatar,
  avatarAlt: 'تصویر آرامش روزخوش',
  bioLines: [
    '⚕ کارآفرین سریالی | کوچ مدیران برای تیم‌سازی، سیستم‌سازی و برند‌سازی',
    '🎯 ۲۷ سال تجربه واقعی در بازار',
    '🔺 همراه بیش از ده برند و تیم موفق...'
  ],
  actions: [
    { label: 'مشاوره رایگان', href: '#consulting', variant: 'primary' },
    { label: 'تماس', href: 'contact.html', variant: 'default' },
    {
      label: 'اینستاگرام',
      href: 'https://www.instagram.com/arameshrouzkhosh',
      variant: 'default',
      external: true
    }
  ]
};

export const profileStories = [
  {
    id: 'profile-intro',
    eyebrow: 'معرفی',
    title: 'آرامش روزخوش؛ مربی کسب و کار',
    image: mainAvatar,
    alt: 'آرامش روزخوش',
    duration: 5000
  },
  {
    id: 'profile-work',
    eyebrow: 'تیم‌سازی',
    title: 'کوچ مدیران برای ساخت تیم‌های پایدار',
    image: videoImage,
    alt: 'جلسه آموزشی تیم‌سازی',
    duration: 5500
  },
  {
    id: 'profile-brand',
    eyebrow: 'برندسازی',
    title: 'از تجربه واقعی بازار تا رشد برند',
    image: sliderImage,
    alt: 'جلسه مربی‌گری با کودک',
    duration: 5500
  }
];

export const highlights = [
  {
    id: 'tips',
    title: 'نکته ی مد...',
    image: highlightTip,
    alt: 'هایلایت نکته‌های مدیریتی',
    stories: [
      {
        eyebrow: 'نکته مدیریتی',
        title: 'سه سوال قبل از ساختن یک تیم جدید',
        image: highlightTip,
        alt: 'کاور نکته مدیریتی',
        duration: 4500
      },
      {
        eyebrow: 'نکته مدیریتی',
        title: 'وقتی نقش‌ها شفاف نیستند، انرژی تیم هدر می‌رود',
        image: videoImage,
        alt: 'جلسه کاری با نمودار',
        duration: 5500
      }
    ]
  },
  {
    id: 'aramesh',
    title: 'آرامش',
    image: highlightAramesh,
    alt: 'هایلایت آرامش',
    stories: [
      {
        eyebrow: 'آرامش',
        title: 'آرامش در تصمیم‌های سخت کسب و کار',
        image: highlightAramesh,
        alt: 'کاور آرامش',
        duration: 4500
      },
      {
        eyebrow: 'آرامش',
        title: 'چطور روز کاری خود را سبک‌تر شروع کنیم؟',
        image: podcastImage,
        alt: 'مادر و کودک در فضای آموزشی',
        duration: 5500
      }
    ]
  },
  {
    id: 'coaching',
    title: 'کوچینگ',
    image: highlightCoaching,
    alt: 'هایلایت کوچینگ',
    stories: [
      {
        eyebrow: 'کوچینگ',
        title: 'کوچینگ یعنی دیدن ریشه رفتار تیم',
        image: highlightCoaching,
        alt: 'کاور کوچینگ',
        duration: 4500
      },
      {
        eyebrow: 'کوچینگ',
        title: 'گفتگوهای دقیق، خروجی‌های دقیق‌تر می‌سازند',
        image: articleImage,
        alt: 'پدر و کودک در خانه',
        duration: 5500
      }
    ]
  },
  {
    id: 'love',
    title: 'عشق',
    image: highlightLove,
    alt: 'هایلایت عشق',
    stories: [
      {
        eyebrow: 'روابط کاری',
        title: 'توجه واقعی، جایگزین کنترل بیش از حد می‌شود',
        image: highlightLove,
        alt: 'کاور عشق',
        duration: 4500
      },
      {
        eyebrow: 'روابط کاری',
        title: 'تیم‌ها با شنیده شدن، مسئولیت‌پذیرتر می‌شوند',
        image: sliderImage,
        alt: 'مادر و کودک در حال نقاشی',
        duration: 5500
      }
    ]
  },
  {
    id: 'motivation',
    title: 'انگیزشی',
    image: highlightMotivation,
    alt: 'هایلایت انگیزشی',
    stories: [
      {
        eyebrow: 'انگیزشی',
        title: 'حرکت کوچک امروز، مسیر فردا را عوض می‌کند',
        image: highlightMotivation,
        alt: 'کاور انگیزشی',
        duration: 4500
      },
      {
        eyebrow: 'انگیزشی',
        title: 'موفقیت تیمی با تمرین‌های روزمره ساخته می‌شود',
        image: videoImage,
        alt: 'جلسه آموزشی تیمی',
        duration: 5500
      }
    ]
  }
];

export const postTypes = {
  video: {
    label: 'ویدئو',
    icon: videoIcon,
    accent: 'blue'
  },
  podcast: {
    label: 'پادکست',
    icon: podcastIcon,
    accent: 'purple'
  },
  slider: {
    label: 'اسلایدی',
    icon: sliderIcon,
    accent: 'pink'
  },
  article: {
    label: 'مقاله',
    icon: articleIcon,
    accent: 'yellow'
  }
};

const commonTitle = 'چرا شادکردن کارکنان واقعا نتیجه می‌دهد؟';

export const posts = [
  {
    id: 1,
    type: 'video',
    time: '۸ ثانیه قبل',
    title: commonTitle,
    image: videoImage,
    alt: 'جلسه ارائه درباره شادی کارکنان',
    href: '#post-video-1',
    mediaUrl: demoVideoUrl
  },
  {
    id: 2,
    type: 'podcast',
    time: '۸ ثانیه قبل',
    title: commonTitle,
    image: podcastImage,
    alt: 'مادر و کودک در حال نقاشی',
    href: '#post-podcast-1',
    mediaUrl: demoAudioUrl
  },
  {
    id: 3,
    type: 'slider',
    time: '۸ ثانیه قبل',
    title: commonTitle,
    image: sliderImage,
    alt: 'مادر و کودک در حال نقاشی',
    href: '#post-slider-1',
    slides: [
      { image: sliderImage, alt: 'مادر و کودک در حال نقاشی' },
      { image: articleImage, alt: 'پدر در کنار کودک ناراحت' },
      { image: videoImage, alt: 'جلسه ارائه درباره شادی کارکنان' }
    ]
  },
  {
    id: 4,
    type: 'article',
    time: '۸ ثانیه قبل',
    title: commonTitle,
    image: articleImage,
    alt: 'پدر در کنار کودک ناراحت',
    href: '#post-article-1'
  },
  {
    id: 5,
    type: 'article',
    time: '۸ ثانیه قبل',
    title: commonTitle,
    image: articleImage,
    alt: 'پدر در کنار کودک ناراحت',
    href: '#post-article-2'
  },
  {
    id: 6,
    type: 'article',
    time: '۸ ثانیه قبل',
    title: commonTitle,
    image: articleImage,
    alt: 'پدر در کنار کودک ناراحت',
    href: '#post-article-3'
  },
  {
    id: 7,
    type: 'video',
    time: '۸ ثانیه قبل',
    title: commonTitle,
    image: videoImage,
    alt: 'جلسه ارائه درباره شادی کارکنان',
    href: '#post-video-2',
    mediaUrl: demoVideoUrl
  },
  {
    id: 8,
    type: 'podcast',
    time: '۸ ثانیه قبل',
    title: commonTitle,
    image: podcastImage,
    alt: 'مادر و کودک در حال نقاشی',
    href: '#post-podcast-2',
    mediaUrl: demoAudioUrl
  },
  {
    id: 9,
    type: 'slider',
    time: '۸ ثانیه قبل',
    title: commonTitle,
    image: sliderImage,
    alt: 'مادر و کودک در حال نقاشی',
    href: '#post-slider-2',
    slides: [
      { image: sliderImage, alt: 'مادر و کودک در حال نقاشی' },
      { image: podcastImage, alt: 'مادر و کودک با دفتر نقاشی' },
      { image: articleImage, alt: 'پدر در کنار کودک ناراحت' }
    ]
  },
  {
    id: 10,
    type: 'article',
    time: '۸ ثانیه قبل',
    title: commonTitle,
    image: articleImage,
    alt: 'پدر در کنار کودک ناراحت',
    href: '#post-article-4'
  },
  {
    id: 11,
    type: 'article',
    time: '۸ ثانیه قبل',
    title: commonTitle,
    image: articleImage,
    alt: 'پدر در کنار کودک ناراحت',
    href: '#post-article-5'
  },
  {
    id: 12,
    type: 'article',
    time: '۸ ثانیه قبل',
    title: commonTitle,
    image: articleImage,
    alt: 'پدر در کنار کودک ناراحت',
    href: '#post-article-6'
  }
];

export const aboutPage = {
  hero: {
    eyebrow: 'درباره ما',
    title: 'ما روی رشد انسانیِ پشت رشد کسب و کار کار می‌کنیم.',
    summary:
      'در آرامش روزخوش، کوچینگ، سیستم‌سازی و بازطراحی رفتار تیمی را کنار هم می‌گذاریم تا رشد فقط در عدد نماند و در تصمیم، فرهنگ و عملکرد هم دیده شود.'
  },
  stats: [
    { value: '۲۷+', label: 'سال تجربه بازار' },
    { value: '۱۲۰+', label: 'پروژه مشاوره و کوچینگ' },
    { value: '۱۸', label: 'صنعت همراهی شده' },
    { value: '۹۲٪', label: 'نرخ تداوم همکاری' }
  ],
  story: [
    {
      title: 'شروع از دل تجربه واقعی',
      text: 'این مسیر از دل بازار، مدیریت روزانه، ساخت تیم و مواجهه مستقیم با بحران‌های واقعی شکل گرفته است؛ نه فقط از دل تئوری.'
    },
    {
      title: 'تمرکز روی انسان و سیستم با هم',
      text: 'اگر فقط سیستم بسازیم، تیم فرسوده می‌شود. اگر فقط انگیزه بدهیم، خروجی پایدار نمی‌ماند. مدل ما این دو را همزمان جلو می‌برد.'
    },
    {
      title: 'نتیجه قابل سنجش',
      text: 'هدف ما فقط حس خوب نیست؛ وضوح نقش، کاهش اصطکاک، تصمیم‌گیری بهتر و رشد قابل اندازه‌گیری برای مدیر و تیم مهم است.'
    }
  ],
  principles: [
    {
      title: 'کوچینگ مدیر',
      text: 'شفاف کردن الگوهای تصمیم، ارتباط و رهبری برای ساختن تیمی که روی دوش یک نفر نماند.'
    },
    {
      title: 'طراحی فرهنگ تیمی',
      text: 'چیدن توافق‌ها، نقش‌ها و ریتم‌های کاری که کیفیت همکاری را در عمل بالا ببرد.'
    },
    {
      title: 'سیستم سازی رشد',
      text: 'مستندسازی، اولویت‌بندی و تبدیل تجربه فردی به فرآیند تکرارپذیر برای مقیاس‌پذیری.'
    }
  ],
  milestones: [
    { year: '۱۳۸۶', title: 'شروع کار حرفه‌ای', text: 'ورود جدی به مسیر آموزش، مدیریت و همراهی کسب و کارها.' },
    { year: '۱۳۹۳', title: 'تمرکز بر کوچینگ سازمانی', text: 'طراحی مدل‌های اختصاصی برای تیم‌سازی، گفتگو و رشد مدیران.' },
    { year: '۱۴۰۰', title: 'توسعه برند آرامش روزخوش', text: 'تمرکز روی تجربه دیجیتال، محتوا و همراهی مستمر با مخاطبان.' }
  ],
  featuredPosts: [posts[0], posts[1], posts[2]],
  quote:
    'رشد پایدار از جایی شروع می‌شود که مدیر، تیم و سیستم با هم دیده شوند؛ نه جدا از هم.',
  cta: {
    title: 'اگر می‌خواهی تیم تو سبک‌تر، شفاف‌تر و قابل اتکاتر کار کند، از همین‌جا شروع می‌کنیم.',
    text: 'یک جلسه اولیه برای شناخت وضعیت فعلی، گره‌های اصلی و مسیر مناسب همکاری کافی است.',
    button: { label: 'درخواست جلسه', href: 'contact.html' }
  }
};

export const productCategories = [
  { key: 'courses', label: 'دوره‌های آموزشی' },
  { key: 'ebooks', label: 'کتاب‌های الکترونیکی' },
  { key: 'workbooks', label: 'ورک‌بوک و ابزار' }
];

export const products = [
  {
    id: 'product-001',
    slug: 'team-design-course',
    type: 'course',
    category: 'courses',
    title: 'دوره طراحی تیم همدل و نتیجه‌محور',
    shortTitle: 'دوره تیم همدل',
    image: videoImage,
    price: '۳,۹۸۰,۰۰۰',
    oldPrice: '۴,۹۵۰,۰۰۰',
    badge: 'پرفروش',
    href: 'product.html',
    format: 'ویدئویی + فایل تمرین',
    duration: '۸ ساعت آموزش',
    lessons: '۲۴ جلسه',
    level: 'مدیران و رهبران تیم',
    excerpt:
      'مسیر عملی برای ساختن تیمی با نقش‌های روشن، گفتگوهای سالم و خروجی پایدار. مناسب مدیرانی که می‌خواهند تیم از وابستگی به فرد خارج شود.',
    description:
      'این دوره برای مدیرانی طراحی شده که درگیر فرسودگی تیم، ابهام نقش‌ها، کیفیت پایین جلسات یا وابستگی شدید عملیات به چند نفر کلیدی هستند.',
    features: [
      'نقشه ساخت تیم با نقش‌های روشن و قابل سنجش',
      'مدل گفتگو و بازخورد برای کاهش اصطکاک روزانه',
      'قالب جلسه هفتگی، تصمیم‌گیری و پیگیری اجرا',
      'ورک‌بوک اجرایی برای پیاده‌سازی داخل تیم'
    ],
    audience: [
      'مدیران عامل و مدیران میانی',
      'رهبران تیم در شرکت‌های خدماتی و آموزشی',
      'کسب و کارهایی که رشدشان از تیم جلو زده است'
    ],
    curriculum: [
      { title: 'درک الگوی فعلی تیم', time: '۳۸ دقیقه' },
      { title: 'بازتعریف نقش‌ها و مسئولیت‌ها', time: '۴۶ دقیقه' },
      { title: 'جلسات هفتگی و تصمیم‌سازی موثر', time: '۳۲ دقیقه' },
      { title: 'فرهنگ گفت‌وگو، بازخورد و پیگیری', time: '۵۱ دقیقه' }
    ]
  },
  {
    id: 'product-002',
    slug: 'manager-focus-ebook',
    type: 'ebook',
    category: 'ebooks',
    title: 'کتاب الکترونیکی تمرکز مدیر در روزهای شلوغ',
    shortTitle: 'کتاب تمرکز مدیر',
    image: articleImage,
    price: '۳۹۸,۰۰۰',
    oldPrice: '',
    badge: 'کتاب',
    href: 'product.html?item=manager-focus-ebook',
    format: 'PDF + نسخه موبایل',
    duration: '۱۷۴ صفحه',
    lessons: '۹ فصل',
    level: 'برای مدیران و صاحبان کسب و کار',
    excerpt:
      'کتابی درباره تصمیم‌گیری، تمرکز و کاهش آشفتگی ذهنی مدیر در زمانی که کارها زیاد و زمان کم است.',
    description:
      'این کتاب الکترونیکی با مثال‌های واقعی از محیط کار، به مدیر کمک می‌کند بین فوریت، اهمیت و فشار روانی تفاوت بگذارد و اولویت‌ها را دوباره بچیند.',
    features: [
      'فصل‌های کوتاه و قابل استفاده در زمان کم',
      'چک‌لیست‌های اجرایی برای برنامه‌ریزی هفتگی',
      'نسخه مناسب موبایل برای مطالعه روزانه',
      'پرسش‌های خودارزیابی پایان هر فصل'
    ],
    audience: [
      'مدیرانی که احساس پراکندگی در تصمیم‌ها دارند',
      'صاحبان کسب و کارهای کوچک و در حال رشد',
      'کسانی که دنبال محتوای فشرده و کاربردی هستند'
    ],
    curriculum: [
      { title: 'تشخیص آشفتگی پنهان', time: 'فصل ۱' },
      { title: 'ساختن فیلتر تصمیم', time: 'فصل ۳' },
      { title: 'مدیریت انرژی به جای مدیریت زمان', time: 'فصل ۶' },
      { title: 'روتین تمرکز برای روزهای شلوغ', time: 'فصل ۹' }
    ]
  },
  {
    id: 'product-003',
    slug: 'culture-workbook',
    type: 'workbook',
    category: 'workbooks',
    title: 'ورک‌بوک طراحی فرهنگ تیمی',
    shortTitle: 'ورک‌بوک فرهنگ تیمی',
    image: sliderImage,
    price: 'رایگان',
    oldPrice: '',
    badge: 'رایگان',
    href: 'product.html?item=culture-workbook',
    format: 'PDF قابل چاپ',
    duration: '۵۴ صفحه',
    lessons: '۱۲ تمرین',
    level: 'تیم‌های ۳ تا ۳۰ نفر',
    excerpt:
      'ابزار اجرایی برای مدیرانی که می‌خواهند توافق‌های تیمی را بنویسند، شفاف کنند و در عمل به آن برگردند.',
    description:
      'ورک‌بوکی برای تسهیل جلسه‌های داخلی تیم، ثبت توافق‌ها، تنظیم انتظارات و کاهش ابهام در همکاری روزانه.',
    features: [
      'قالب آماده برای توافق‌های تیمی',
      'برگه‌های جلسه و پیگیری تصمیم‌ها',
      'تمرین طراحی نقش و مرز مسئولیت',
      'فایل مناسب چاپ و استفاده در جلسه'
    ],
    audience: [
      'تیم‌های کوچک و متوسط',
      'مدیرانی که می‌خواهند فرهنگ را مستند کنند',
      'تسهیل‌گرانی که جلسه داخلی تیم را پیش می‌برند'
    ],
    curriculum: [
      { title: 'تعریف ارزش‌های قابل رفتار', time: 'تمرین ۲' },
      { title: 'نوشتن توافق‌های همکاری', time: 'تمرین ۵' },
      { title: 'مرزبندی نقش‌ها', time: 'تمرین ۸' },
      { title: 'مرور و اصلاح دوره‌ای', time: 'تمرین ۱۲' }
    ]
  },
  {
    id: 'product-004',
    slug: 'leader-coaching-course',
    type: 'course',
    category: 'courses',
    title: 'دوره کوچینگ مدیر برای گفتگوهای سخت',
    shortTitle: 'کوچینگ گفتگوهای سخت',
    image: podcastImage,
    price: '۲,۴۸۰,۰۰۰',
    oldPrice: '',
    badge: 'جدید',
    href: 'product.html?item=leader-coaching-course',
    format: 'ویدئو + تمرین تعاملی',
    duration: '۵ ساعت آموزش',
    lessons: '۱۴ جلسه',
    level: 'مدیران میانی و رهبران تیم',
    excerpt:
      'برای زمانی که باید گفتگوی سخت، بازخورد جدی یا مرزبندی روشن داشته باشی اما نمی‌خواهی رابطه تیمی آسیب ببیند.',
    description:
      'این دوره مدیر را برای گفتگوهای حساس آماده می‌کند؛ از تنظیم فضا و لحن تا پیگیری بعد از جلسه و بستن حلقه توافق.',
    features: [
      'سناریوهای واقعی از تیم و سازمان',
      'الگوی مکالمه برای موقعیت‌های حساس',
      'فایل تمرین و self-review',
      'رویکرد کاربردی برای پیاده‌سازی فوری'
    ],
    audience: [
      'رهبران تیم در حال رشد',
      'مدیرانی که در بازخورد دادن مشکل دارند',
      'تیم‌هایی که گفتگوی مستقیم برایشان دشوار است'
    ],
    curriculum: [
      { title: 'آماده‌سازی ذهنی قبل از گفتگو', time: '۲۵ دقیقه' },
      { title: 'شروع گفتگو بدون دفاع‌برانگیزی', time: '۳۴ دقیقه' },
      { title: 'رسیدن به توافق عملی', time: '۲۹ دقیقه' },
      { title: 'پیگیری و تثبیت نتیجه', time: '۳۷ دقیقه' }
    ]
  }
];

export const shopPage = {
  hero: {
    eyebrow: 'فروشگاه',
    title: 'دوره، کتاب و ابزارهایی که برای اجرا ساخته شده‌اند، نه فقط برای خواندن.',
    summary:
      'محصولات این صفحه بیشتر حول آموزش‌های کاربردی، کتاب‌های الکترونیکی و ورک‌بوک‌هایی شکل گرفته‌اند که مدیر بتواند آن‌ها را مستقیم وارد کار روزانه کند.'
  },
  highlights: [
    { title: 'دوره‌های آموزشی', text: 'محتوای ویدئویی و ساختاریافته برای مدیران و رهبران تیم' },
    { title: 'کتاب‌های الکترونیکی', text: 'محتوای فشرده، سریع و قابل مطالعه روی موبایل و دسکتاپ' },
    { title: 'ابزارهای اجرایی', text: 'ورک‌بوک، چک‌لیست و فایل‌های آماده برای جلسه و اجرا' }
  ],
  featured: [products[0], products[1]]
};

export const cartPage = {
  items: [
    { productId: 'product-001', quantity: 1 },
    { productId: 'product-002', quantity: 1 }
  ],
  couponHint: 'کد تخفیف یا هدیه را اینجا وارد کنید',
  totals: {
    subtotal: '۴,۳۷۸,۰۰۰',
    discount: '۳۹۸,۰۰۰',
    total: '۳,۹۸۰,۰۰۰'
  }
};

export const checkoutPage = {
  customer: {
    firstName: 'آرزو',
    lastName: 'محمدی',
    phone: '۰۹۱۲۱۲۳۴۵۶۷',
    email: 'sample@example.com'
  },
  billing: {
    province: 'تهران',
    city: 'تهران',
    address: 'خیابان شریعتی، بالاتر از میرداماد، پلاک نمونه',
    postalCode: '۱۵۴۸۷۳۶۹۱۲'
  },
  paymentMethods: [
    { key: 'online', label: 'پرداخت آنلاین', description: 'اتصال به درگاه بانکی و پرداخت ایمن' },
    { key: 'wallet', label: 'کیف پول', description: 'کسر مبلغ از اعتبار حساب کاربری' }
  ]
};

export const accountPage = {
  cards: [
    { title: 'دوره‌های من', value: '۳ محصول', text: 'دسترسی فعال به ویدئوها و فایل‌های همراه' },
    { title: 'دانلودهای اخیر', value: '۵ فایل', text: 'کتاب‌ها و ورک‌بوک‌های خریداری شده' },
    { title: 'سفارش‌های تکمیل شده', value: '۱۲', text: 'سوابق خرید و پرداخت‌های موفق' }
  ],
  recentOrders: [
    { id: '4581', date: '۱۴۰۵/۰۳/۱۰', status: 'تکمیل شده', total: '۳,۹۸۰,۰۰۰ تومان' },
    { id: '4519', date: '۱۴۰۵/۰۲/۲۱', status: 'در انتظار پرداخت', total: '۷۹۰,۰۰۰ تومان' }
  ],
  downloads: [
    { name: 'کتاب تمرکز مدیر', format: 'PDF', date: '۱۴۰۵/۰۳/۱۰' },
    { name: 'ورک‌بوک طراحی فرهنگ تیمی', format: 'PDF قابل چاپ', date: '۱۴۰۵/۰۲/۲۱' }
  ]
};

export const orderReceivedPage = {
  orderNumber: '5842',
  date: '۱۴۰۵/۰۳/۱۶',
  total: '۳,۹۸۰,۰۰۰ تومان',
  email: 'sample@example.com',
  nextSteps: [
    'لینک دسترسی محصولات به ایمیل شما ارسال شد.',
    'همه دانلودها از حساب کاربری نیز در دسترس هستند.',
    'برای دوره‌ها، ویدئوها بلافاصله از بخش دوره‌های من فعال می‌شوند.'
  ]
};
